import { useParams } from "react-router-dom";
export function useAlternative() { const params = useParams(); return params.alternative ? parseInt(params.alternative) : 0; }
